<template>
    <v-container fluid>
      <h2>{{ $t('excluded_route_plan_ui.excluded_route_plans') }}</h2>
      <v-sheet outlined rounded class="px-4 py-2">
        <div class="text-subtitle-1">{{ $t('filter_by') }}</div>
        <v-row dense>
          <v-col lg="2" md="6" cols="12">
            <v-text-field
              :label="$t('route_name')"
              v-model="searchCriteria.route_number"
              @keyup.enter="initiateSearch"
              prepend-inner-icon="mdi-road-variant">
            </v-text-field>
          </v-col>
          <v-col class="d-flex align-center" lg="3" md="4" cols="12">
            <date-picker
              v-model="searchCriteria.created_after"
              :timezone="customerTimezone"
              :label="$t('created_after')"
              prepend-inner-icon="mdi-calendar"
              reset-on-timezone-change />
            <date-picker
              v-model="searchCriteria.created_before"
              :timezone="customerTimezone"
              :label="$t('created_before')"
              prepend-inner-icon="mdi-calendar"
              end-of-day
              reset-on-timezone-change />
          </v-col>
        </v-row>
        <div class="d-flex justify-end mt-1 mb-2">
          <v-btn outlined color="primary" @click="initiateSearch()" :loading="remoteData.isBusy">
            <v-icon class="mr-1 ml-n1">mdi-magnify</v-icon>
            {{ $t('search') }}
          </v-btn>
          <v-btn outlined color="primary" class="ml-2" @click="resetTable()" :disabled="tableControlsMatchDefaults">
            <v-icon class="mr-1 ml-n1">mdi-filter-remove</v-icon>
            {{ $t('reset') }}
          </v-btn>
        </div>
      </v-sheet>
      <div class="data-table-wrapper" :class="{'loading': remoteData.isBusy}">
        <v-data-table
          condensed
          :headers="headers"
          :items="remoteData.items">
          <template #item.created="row">
            {{ Moment(row.item.created).format('LLL') }}
          </template>
        </v-data-table>
      </div>
    </v-container>
</template>
<script>

import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import RemoteDataTableMixin from '@/components/mixins/RemoteDataTableMixin'
import ApiUtilitiesMixin from '@/components/mixins/ApiUtilitiesMixin'
import Moment from 'moment-timezone'
import DatePicker from '@/components/shared/DatePicker.vue'

export default {
  name: 'RoutePlanExcludeIndex',
  components: { DatePicker },
  mixins: [CurrentUserMixin, RemoteDataTableMixin, ApiUtilitiesMixin],
  data () {
    return {
      model: 'RoutePlanExclude',
      searchCriteria: this.getDefaultSearchCriteria(),
      headers: [
        { text: this.$t('excluded_route_plan_ui.created'), value: 'created' },
        { text: this.$t('excluded_route_plan_ui.name'), value: 'route_plan_name' },
        { text: this.$t('excluded_route_plan_ui.description'), value: 'routePlanRule.description' }
      ]
    }
  },
  methods: {
    Moment,
    getDefaultSearchCriteria () {
      return {
        customer_id: this.customerContextId,
        route_number: null,
        created_after: null,
        created_before: null
      }
    },
    buildSearchCriteria () {
      const searchCriteria = {
        expand: 'routePlanRule',
        fields: 'id, created, route_plan_name, route_plan_rule, description, route_plan_rule.description',
        customer_id: this.customerContextId,
        page: this.remoteData.currentPage,
        'per-page': this.remoteData.rowsPerPage
      }
      if (this.searchCriteria.route_number != null) {
        searchCriteria.route_number = this.searchCriteria.route_number
      }
      if (this.searchCriteria.created_after != null) {
        searchCriteria.created_after = this.searchCriteria.created_after
      }
      if (this.searchCriteria.created_before != null) {
        searchCriteria.created_before = this.searchCriteria.created_before
      }
      if (this.remoteData.sortBy !== null) {
        const sortDirection = this.remoteData.sortDesc ? '-' : ''
        searchCriteria.sort = `${sortDirection}${this.remoteData.sortBy}`
      }

      return searchCriteria
    }
  },
  computed: {

  },
  created () {
    this.refreshResults()
  }
}
</script>
